module.exports = __webpack_public_path__ + "static/media/medical.9c7b7954.png";